import { ParticipantCandidate } from '../_state/_types';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const contactListAtom = createQueryAtomFactory(
  'chat.contactList',
  (params: { searchTerm?: string; contactIds?: string[] }) => ({
    userContactsList: {
      __args: {
        filter: {
          searchTerm: params.searchTerm,
          limit: 10_000,
          offset: 0,
        },
      },
      data: {
        id: true,
        name: true,
        email: true,
        phone: true,
        contactType: true,
        organizationName: true,
      },
    },
  }),
  {
    select: ({ userContactsList }) =>
      userContactsList.data.map(
        (contact): ParticipantCandidate => ({
          id: contact.id,
          type: contact.contactType,
          name: contact.name,
          email: contact.email ?? undefined,
          phoneNumber: contact.phone ?? undefined,
          organizationName: contact.organizationName ?? undefined,
        }),
      ),
  },
);
